// extracted by mini-css-extract-plugin
module.exports = {"layout":"index_layout__3n6L9","layout__content":"index_layout__content__3PAsy"};